<style scoped src="css/pcData.css"></style>
<template>
  <div class="box">
    <img class="imgCenter" src="~assets/pcTitle.png" alt="" />
    <div class="content">
      <div class="block1">
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">矫正对象概况</div></div>
          <div class="zjBox">
            <div class="zjItemBox">
              <img src="~assets/jzImg.png" alt="" />
              <div>
                <div class="zjName">{{ userMap.huanxing }} <span>人</span></div>
                <div class="doctorProfile">缓刑</div>
              </div>
            </div>
            <div class="zjItemBox">
              <img src="~assets/jzImg.png" alt="" />
              <div>
                <div class="zjName">{{ userMap.jianwai }} <span>人</span></div>
                <div class="doctorProfile">暂于监外</div>
              </div>
            </div>
            <div class="zjItemBox">
              <img src="~assets/jzImg.png" alt="" />
              <div>
                <div class="zjName">{{ userMap.jiashi }} <span>人</span></div>
                <div class="doctorProfile">假释</div>
              </div>
            </div>
            <div class="zjItemBox">
              <img src="~assets/jzImg.png" alt="" />
              <div>
                <div class="zjName">{{ userMap.guanzhi }} <span>人</span></div>
                <div class="doctorProfile">管制</div>
              </div>
            </div>
          </div>
        </div>
        <div class="itemBox">
          <div class="fzTitle">犯罪类型统计</div>
          <div id="myChart3"></div>
        </div>
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">评价体系</div></div>
          <div class="pjtxBox">
            <div id="myChart4"></div>
            <div id="myChart5"></div>
          </div>
        </div>
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">共享数据</div></div>
          <div class="gxsjBox"><img src="~assets/gxsj.png" alt=""></div>

        </div>
      </div>
      <div class="block2">
        <div class="itemBox" @click="to('pcData1')">
          <!-- <div class="titleBox" @click="to('pcData1')">
            <div class="titleWord">联防联控</div>
          </div> -->
          <div class="canvasBox">
            <div class="lflkTitle">天台县社区矫正网络化管理图</div>
            <div class="lflkData">
              <img src="~assets/lflkData.png" alt="" />
              <div class="rebOX">
                <div class="centenBox">
                  <div class="centerBoxNum">{{dataMap.zhuce}}</div>
                  社区矫正对象注册人数
                </div>
                <div class="centenBox">
                  <div class="centerBoxNum">{{dataMap.zhongdian}}</div>
                  11月重点人数
                </div>
                <div class="centenBox">
                  <div class="centerBoxNum">{{dataMap.yujing}}</div>
                  今日预警
                </div>
              </div>
            </div>
            <!-- <div id="tiantaiMap"></div> -->
            <img src="~assets/ditu.png" alt="" />
          </div>
        </div>
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">中队划分</div></div>
          <div class="zhongduiBox">
            <div class="zdData" v-for="(item,index) in branchMap" :key="index">
              <div class="zdTitle">{{item.area}}</div>
              <div class="itemBox" v-for="(v,i) in item.list" :key="i">{{v}}</div>
            </div>
          </div>
        </div>
        <!-- <div class="itemBox">
          <div class="titleBox"><div class="titleWord">犯罪认知度</div></div>
          <div class="jjqkBox">
            <div class="jjLine"></div>
            <div class="jjBox">
              <div
                class="jjItem"
                v-for="(item, index) in userTestLevelList2"
                :key="index"
              >
                {{ item.level }}
                <div class="jjNum">{{ item.testCount }}</div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="block3">
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">社会帮扶e联动</div></div>
          <div class="genderBox">
            <div id="myChart"></div>
          </div>
        </div>
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">心理趋势</div></div>
          <div class="qsBox">
            <div id="myChart1"></div>
          </div>
        </div>
        <div class="itemBox">
          <div class="titleBox"><div class="titleWord">在线学习</div></div>
          <div class="qsBox">
            <div id="myChart2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";
import noMoreData from "components/no-more-data";
import newsTopBox from "components/newsTopBox";
import topbar from "components/topbar";
import moment from "moment/moment";
import footerBox from "components/footer";
import { Swiper, Slide } from "vue-swiper-component";
import wx from "weixin-js-sdk";
import echarts from "echarts";
import tiantai from "../ttx.json";
let components = {
  noMoreData,
  topbar,
  Swiper,
  Slide,
  footerBox,
  newsTopBox,
};
export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      comboLearnX: null,
      comboLearnY: null,
      comboLevelT1: null,
      comboLevelT2: null,
      comboLevelT3: null,
      comboLevelT4: null,
      comboLevelX: null,
      doctorList: null,
      userMap: { huanxing: 0, jianwai: 0, jiashi: 0, guanzhi: 0 },
      userGenderMap: null,
      userTestLevelList1: null,
      userTestLevelList2: null,
      offlineCourseList: null,
      crimeMapX: null,
      crimeMapY: null,
      branchMap: null,
      dataMap:{zhuce:0,zhongdian:0,yujing:0},
      scaleMap:{ceping:100,shenhe:100},
    };
  },
  components: components,
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
    isJz(index) {
      return ["缓刑", "暂于监外", "假释", "管制"][index];
    },
  },
  computed: {},
  methods: {

    changeZcTabStatus(i) {
      this.zcTabStatus = i;
    },
    changeCxStatus(i) {
      this.cxStatus = i;
    },
    closeMask() {
      this.mask = false;
      this.ggtpStatus = 0;
      this.zcStatus = 0;
    },
    changeGgtpStatus(i) {
      if (i == 0) {
        this.flag = true;
        this.mask = false;
      } else {
        this.flag = false;
        this.mask = true;
      }
      this.ggtpStatus = i;
    },
    changeStatus(i) {
      this.tabStatus = i;
    },
    changeTtTabStatus(i) {
      this.ttTabStatus = i;
    },
    changeTtTypeStatus(i) {
      this.ttTypeStatus = i;
    },
    changegzStatus(i) {
      this.gzStatus = i;
    },
    changegcCStatus(i) {
      this.gcCStatus = i;
    },
    changezcStatus(i) {
      if (i > 0) {
        this.flag = false;
        this.mask = true;
      } else {
        this.flag = true;
        this.mask = false;
      }
      this.zcStatus = i;
    },
    changeGzdtStatus(i) {
      if (i == -1) {
        this.flag = true;
      } else {
        this.flag = false;
      }
      this.gzdtStatus = i;
    },
    change(i) {
      this.val = [];
      this.id = i;
      if (i == 2) {
        this.workUserList.forEach((v) => {
          this.val.push(v.twoCount);
        });
      } else if (i == 3) {
        this.workUserList.forEach((v) => {
          this.val.push(v.oneCount);
        });
      } else if (i == 4) {
        this.workUserList.forEach((v) => {
          this.val.push(v.zeroCount);
        });
      } else if (i == 1) {
        this.workUserList.forEach((v) => {
          this.val.push(v.threeCount);
        });
      } else {
        this.workUserList.forEach((v) => {
          this.val.push(v.zeroCount + v.oneCount + v.twoCount + v.threeCount);
        });
      }
      this.aa();
    },
    toDetail(i) {
      this.$router.push(`/informationWord?index=${i + 1}`);
    },
    async setEcharts() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById("myChart"));
      var myChart1 = echarts.init(document.getElementById("myChart1"));
      var myChart2 = echarts.init(document.getElementById("myChart2"));
      var myChart3 = echarts.init(document.getElementById("myChart3"));
      var myChart4 = echarts.init(document.getElementById("myChart4"));
      var myChart5 = echarts.init(document.getElementById("myChart5"));
      // let tiantaiChart = echarts.init(document.getElementById('tiantaiMap'))

      // 指定图表的配置项和数据
      var option = {
        // title: {
        //     text: `出生地总人数(个)：${this.birthPlaceOne + this.birthPlaceZero}`,
        //     // subtext: '300',
        //     left: 20,
        //     top:20
        // },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: 20,
          bottom: 20,
          data: ["男", "女"],
          textStyle: {
            //图例文字的样式
            color: "#fff",
          },
        },
        color: ["#249CF9", "#FDB628"],
        series: [
          {
            name: "家庭经济情况",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["60%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold",
                fontColor: "#ffffff",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: this.userGenderMap.boy, name: "男" },
              { value: this.userGenderMap.gril, name: "女" },
            ],
          },
        ],
      };
      var option1 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: ["正常", "轻度", "中度", "重度"],
          textStyle: {
            //图例文字的样式
            color: "#fff",
          },
        },
        color: ["#2AC848", "#44C2FF", "#FFB400", "#DE0D0F"],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.comboLevelX,
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              formatter: "{value}%",
            },
          },
        ],
        series: [
          {
            name: "正常",
            type: "bar",
            // stack: "广告",
            data: this.comboLevelT1,
          },
          {
            name: "轻度",
            type: "bar",
            data: this.comboLevelT2,
          },
          {
            name: "中度",
            type: "bar",
            data: this.comboLevelT3,
          },
          {
            name: "重度",
            type: "bar",
            data: this.comboLevelT4,
          },
        ],
      };

      var option2 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#11C0FF",
            },
          },
        },
        xAxis: {
          type: "category",
          data: this.comboLearnX,
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            data: this.comboLearnY,
            type: "line",
            symbol: "none",
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#11C0FF",
                },
              },
            },
          },
        ],
      };
      var option3 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#11C0FF",
            },
          },
        },
        xAxis: {
          type: "category",
          data: this.crimeMapX,
          axisLabel:{
            rotate:"45"
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            data: this.crimeMapY,
            type: "line",
            symbol: "none",
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#11C0FF",
                },
              },
            },
          },
        ],
      };

      let option4 = {
        title: {
          text: `测评`,
          x: "center",
          y: "bottom",
          textStyle: {
            //文字颜色
            color: "#A8B2E5",
            //字体大小
            fontSize: 18,
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}:{d}%",
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: "20",
                  fontWeight: "bold",
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: [
              {
                name: "已测评",
                value: 98,
                itemStyle: {
                  normal: {
                    color: "#02D9FD",
                    label: {
                      show: true,
                      position: "center",
                      formatter: "{b}:{d}%",
                      textStyle: {
                        baseline: "bottom",
                        fontSize: "16",
                      },
                    },
                    labelLine: {
                      show: true,
                    },
                  },
                },
              },
              {
                name: "未测评",
                value: 2,
                itemStyle: {
                  normal: {
                    color: "#153473",
                  },
                },
              },
            ],
          },
        ],
      };
      let option5 = {
        title: {
          text: `审核`,
          x: "center",
          y: "bottom",
          textStyle: {
            //文字颜色
            color: "#A8B2E5",
            //字体大小
            fontSize: 18,
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}:{d}%",
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: "20",
                  fontWeight: "bold",
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: [
              {
                name: "已审核",
                value: 100,
                itemStyle: {
                  normal: {
                    color: "#249CF9",
                    label: {
                      show: true,
                      position: "center",
                      formatter: "{b}:{d}%",
                      textStyle: {
                        baseline: "bottom",
                        fontSize: "16",
                      },
                    },
                    labelLine: {
                      show: true,
                    },
                  },
                },
              },
              {
                name: "未审核",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#153473",
                  },
                },
              },
            ],
          },
        ],
      };

      // echarts.registerMap('tiantai', tiantai, {})
      // var option3 = {
      //   series: [
      //     {
      //       type: 'map',
      //       mapType: 'tiantai',
      //       label: { show: true }, //显示省份
      //       roam: true,
      //       data: [],
      //     },
      //   ],
      // }

      // tiantaiChart.setOption(option3)

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      myChart1.setOption(option1);
      myChart2.setOption(option2);
      myChart3.setOption(option3);
      myChart4.setOption(option4);
      myChart5.setOption(option5);
    },
    to(n) {
      this.$router.push(`/${n}`);
    },
    clickMe(n) {
      if (n) {
        location.href = n;
      }
    },
    async getWorkService() {
      let data = await getSources(
        "/bear-scale/api/scaleDataScreen/getWorkData",
        {}
      );
      if (data.status === 0) {
        let crimeMap = JSON.parse(data.crimeMap);
        // let userMap = [];
        // data.userMap = JSON.parse(data.userMap)
        // Object.keys(data.userMap).forEach((v, i) => {
        //   userMap.push({
        //     name: v,
        //     value: Object.values(data.userMap)[i],
        //   });
        // });
        this.comboLearnY = data.comboLearnList.reverse().map((item) => {
          return item.timeCount;
        });
        this.comboLearnX = data.comboLearnList.map((item) => {
          return item.month;
        });
        this.comboLevelX = data.comboLevelList.reverse().map((item) => {
          return item.month;
        });
        this.comboLevelT1 = data.comboLevelList.map((item) => {
          return (
            (item.oneLevel /
              (item.oneLevel +
                item.twoLevel +
                item.threeLevel +
                item.fourLevel)) *
            100
          ).toFixed(0);
        });
        this.comboLevelT2 = data.comboLevelList.map((item) => {
          return (
            (item.twoLevel /
              (item.oneLevel +
                item.twoLevel +
                item.threeLevel +
                item.fourLevel)) *
            100
          ).toFixed(0);
        });
        this.comboLevelT3 = data.comboLevelList.map((item) => {
          return (
            (item.threeLevel /
              (item.oneLevel +
                item.twoLevel +
                item.threeLevel +
                item.fourLevel)) *
            100
          ).toFixed(0);
        });
        this.comboLevelT4 = data.comboLevelList.map((item) => {
          return (
            (item.fourLevel /
              (item.oneLevel +
                item.twoLevel +
                item.threeLevel +
                item.fourLevel)) *
            100
          ).toFixed(0);
        });
        this.crimeMapX = crimeMap.map((item) => {
          return item.type;
        });
        this.crimeMapY = crimeMap.map((item) => {
          return item.value;
        });
        // this.doctorList = data.doctorList;
        this.userMap = JSON.parse(data.userMap);
        this.branchMap = JSON.parse(data.branchMap);
        this.dataMap = JSON.parse(data.dataMap);
        this.scaleMap = JSON.parse(data.scaleMap);

        this.userGenderMap = data.userGenderMap;
        // this.userTestLevelList1 = data.userTestLevelList1;
        // this.userTestLevelList2 = data.userTestLevelList2;
        // this.offlineCourseList = JSON.parse(data.offlineCourseList);
        this.setEcharts();
      } else {
        alert(data.msg);
      }
    },
    changeBespeakAbled(n) {
      this.bespeakAbled = n;
      this.pageIndex = 1;
      this.doctorList = [];
      this.getDoctorList();
    },
    async getScaleData() {
      let obj = {};
      obj.type = 3;
      let data = await getSources(
        "/bear-scale/api/scaleData/getScaleData.json",
        obj
      );
      if (data.status === 0) {
        this.workUserCount =
          data.workUserList[0].zeroCount +
          data.workUserList[0].oneCount +
          data.workUserList[0].twoCount +
          data.workUserList[0].threeCount;
        this.allUserCount = data.workUserList[0].userCount;
        this.drawLine();
      } else {
        alert(data.msg);
      }
    },
    async getScaleData2() {
      let obj = {};
      obj.type = 2;
      let data = await getSources(
        "/bear-scale/api/scaleData/getScaleData.json",
        obj
      );
      if (data.status === 0) {
        this.workUserList = data.workUserList;
        this.workUserList.forEach((v) => {
          this.arr.push(v.shortName);
          this.val.push(v.zeroCount + v.oneCount + v.twoCount + v.threeCount);
        });
        this.aa();
      } else {
        alert(data.msg);
      }
    },
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let bottomOfWindow =
        document.documentElement.offsetHeight -
          scrolltop -
          window.innerHeight <=
        200;
      if (bottomOfWindow && this.isLoading == false) {
        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
          this.noMoreData = true;
        } else {
          this.isLoading = true;
          this.pageIndex = this.pageIndex + 1;
          this.getDoctorList();
        }
      }
    },
    toNone() {
      const isZzd =
        JSON.stringify(navigator.userAgent).indexOf("TaurusApp") > -1;
      if (!isZzd) {
        location.href =
          "https://dgov-integrate.jinhua.gov.cn:5443/szjh-gov-pc/#/404";
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    localStorage.setItem("sp", true);
    document.title = "心理服务";
    // this.drawLine()
    // this.toNone()

    this.getWorkService();
    // this.getScaleData2()
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pcData.vue?55411d15